import { Redirect, Route } from "react-router-dom";

import Layout from "../pages/layout";
import { toast } from "react-toastify";
// import { Container } from './styles';
import { useAuth } from "../context/global";

interface IRouteParams {
    component: any;
    rest?: any[];
    path?: string;
    exact?: any;
}

export default function RouteWapper({ component: Component, ...rest }: IRouteParams) {
    const { handleGetDataUser, routePermission } = useAuth();
    const dados = handleGetDataUser();

    if (routePermission.length > 0 && handleGetDataUser) {
        const element = routePermission.find((item) => {
            return item.router === rest.path;
        });

        if (dados && dados.perfil && element && !element.permissions.includes(dados.perfil.toLowerCase())) {
            toast.error("Você não possui autorização para visualizar essa página.");
            return <Redirect to="/" />;
        }
    }

    return (
        <Route
            {...rest}
            render={(props) => (
                <Layout>
                    <Component {...props} />
                </Layout>
            )}
        />
    );
}
